import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin';
import { DateTimeInput } from 'react-admin-date-inputs';
import { required } from '../../lib/validation';

const redirect = (basePath, id, data) => `/users/${data.user_id}/show/subscriptions`;

const SubscriptionCreate = props => (
  <Create {...props}>
    <SimpleForm redirect={redirect}>
      <DateTimeInput
        label="Start at"
        source="start_at"
        validate={required()}
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <DateTimeInput
        label="End at"
        source="end_at"
        validate={required()}
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <DateTimeInput
        label="Payed at"
        source="payed_at"
        options={{ format: 'dd/MM/yyyy, HH:mm:ss' }}
      />
      <TextInput label="Transaction" source="transaction_id" />
      <ReferenceInput label="Plan" source="plan_id" reference="plans">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="User" source="user_id" reference="users">
        <SelectInput optionText="full_name" options={{ disabled: true }} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default SubscriptionCreate;



// WEBPACK FOOTER //
// ./src/resources/subscriptions/SubscriptionCreate.jsx